export const colorType = {
	PRIMARY: 'Primary',
	SECONDARY: 'Secondary',
	TEXT: 'Text',
	BACKGROUND: 'Background',
	INDICATION: 'Indication',
	OTHERS: 'Others',
	LABEL: 'Label',
	REPORT: 'Report',
	GRADIENT: 'Gradient',
	TABLE: 'Table',
	LOADER: 'Loader',
	OLD_COLORS: 'OldColors',
	CALL_VIEW_COLORS: 'CallViewColors',
};

export const tokens = (mode) => ({
	...(mode === 'light'
		? {
				[colorType.PRIMARY]: {
					blue: {
						100: '#D4E4FA',
						200: '#CBE6FF',
						300: '#A4BCFD',
						400: '#0099FF',
						500: '#0096ff',
						600: '#0086E4',
						700: '#4655D3',
						800: '#003c66',
						900: '#001e33',
					},
					purple: {
						100: '#e5dfff',
						200: '#cac0ff',
						300: '#F7F1FE',
						400: '#F1E5FF',
						500: '#7b61ff',
						600: '#5643CC',
						700: '#6251B5',
						800: '#4C3F8C',
						900: '#191333',
					},
					pink: {
						100: '#FFDED7',
						200: '#FAA7E0',
						300: '#ff84c0',
						400: '#ff5bab',
						500: '#ff3296',
						600: '#fc5555',
						700: '#991e5a',
						800: '#66143c',
						900: '#330a1e',
					},
					yellow: {
						100: '#EBD9B7',
						200: '#F3E87F',
						300: '#ffde72',
						400: '#ffd343',
						500: '#ffc814',
						600: '#cca010',
						700: '#99780c',
						800: '#665008',
						900: '#332804',
					},
					green: {
						100: '#d0f4e0',
						200: '#a1e9c1',
						300: '#72dea2',
						400: '#29CC6A',
						500: '#14c864',
						600: '#10a050',
						700: '#0c783c',
						800: '#085028',
						900: '#042814',
					},

					blackForm: {
						100: '#d0d0d0',
						200: '#a1a1a1',
						300: '#727172',
						400: '#434243',
						500: '#141314',
						600: '#100f10',
						700: '#0c0b0c',
						800: '#080808',
						900: '#040404',
					},
					grey: {
						100: '#ffffff',
						200: '#F8F8F8',
						300: '#E6E6E6',
						400: '#D6D6D6',
						500: '#A5A5A5',
						600: '#777',
						700: '#555',
						800: '#383538',
						900: '#222222',
					},
					black: '#000000',
					white: '#ffffff',
				},
		  }
		: {
				[colorType.PRIMARY]: {
					blue: {
						100: '#001e33',
						200: '#003c66',
						300: '#4655D3',
						400: '#0086E4',
						500: '#0096ff',
						600: '#0099FF',
						700: '#A4BCFD',
						800: '#CBE6FF',
						900: '#D4E4FA',
					},
					purple: {
						100: '#191333',
						200: '#4C3F8C',
						300: '#6251B5',
						400: '#5643CC',
						500: '#7b61ff',
						600: '#F1E5FF',
						700: '#F7F1FE',
						800: '#cac0ff',
						900: '#e5dfff',
					},
					pink: {
						100: '#330a1e',
						200: '#66143c',
						300: '#991e5a',
						400: '#fc5555',
						500: '#ff3296',
						600: '#ff5bab',
						700: '#ff84c0',
						800: '#FAA7E0',
						900: '#FFDED7',
					},
					yellow: {
						100: '#332804',
						200: '#665008',
						300: '#99780c',
						400: '#cca010',
						500: '#ffc814',
						600: '#ffd343',
						700: '#ffde72',
						800: '#F3E87F',
						900: '#EBD9B7',
					},
					green: {
						100: '#042814',
						200: '#085028',
						300: '#0c783c',
						400: '#10a050',
						500: '#14c864',
						600: '#29CC6A',
						700: '#72dea2',
						800: '#a1e9c1',
						900: '#d0f4e0',
					},
					blackForm: {
						100: '#040404',
						200: '#080808',
						300: '#0c0b0c',
						400: '#100f10',
						500: '#141314',
						600: '#434243',
						700: '#727172',
						800: '#a1a1a1',
						900: '#d0d0d0',
					},
					grey: {
						100: '#222222',
						200: '#383538',
						300: '#555',
						400: '#777',
						500: '#A5A5A5',
						600: '#D6D6D6',
						700: '#E6E6E6',
						800: '#F8F8F8',
						900: '#FFFFFF',
					},
					white: '#FFFFFF',
					black: '#000000',
				},
		  }),
});
